<div *ngIf="isLoggedOut">
    <div class="d-flex justify-content-center logout-label">
        {{ logoutInactivity ? 'You were logged out due to inactivity. Click the login button below to login again.' : 'LOGOUT.MESSAGE' | translate }}
    </div>
    <div class="d-flex justify-content-center mt-4">
        <button class="btn btn-primary" type="button" (click)="login()">{{ 'LOGOUT.LOGIN_BUTTON' | translate }}</button>
    </div>
</div>
  